export const APARTMENT_INSURANCE_OPTIONS = [
  { value: "Эд хөрөнгө", label: "Эд хөрөнгө" },
  { value: "Амь нас", label: "Амь нас" },
  { value: "Бусад", label: "Бусад" },
];

export const APARTMENT_DURATION_UNIT_OPTIONS = [
  { value: "жил", label: "жил" },
  { value: "сар", label: "сар" },
];
